/* tslint:disable */
/* eslint-disable */
/**
 * users
 * users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { SetUserDynamicPermissionsRequestPermissionsInner } from './SetUserDynamicPermissionsRequestPermissionsInner';
import {
    SetUserDynamicPermissionsRequestPermissionsInnerFromJSON,
    SetUserDynamicPermissionsRequestPermissionsInnerFromJSONTyped,
    SetUserDynamicPermissionsRequestPermissionsInnerToJSON,
} from './SetUserDynamicPermissionsRequestPermissionsInner';

/**
 * 
 * @export
 * @interface SetUserDynamicPermissionsRequest
 */
export interface SetUserDynamicPermissionsRequest {
    /**
     * 
     * @type {Array<SetUserDynamicPermissionsRequestPermissionsInner>}
     * @memberof SetUserDynamicPermissionsRequest
     */
    permissions?: Array<SetUserDynamicPermissionsRequestPermissionsInner>;
}

/**
 * Check if a given object implements the SetUserDynamicPermissionsRequest interface.
 */
export function instanceOfSetUserDynamicPermissionsRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SetUserDynamicPermissionsRequestFromJSON(json: any): SetUserDynamicPermissionsRequest {
    return SetUserDynamicPermissionsRequestFromJSONTyped(json, false);
}

export function SetUserDynamicPermissionsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetUserDynamicPermissionsRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'permissions': !exists(json, 'permissions') ? undefined : ((json['permissions'] as Array<any>).map(SetUserDynamicPermissionsRequestPermissionsInnerFromJSON)),
    };
}

export function SetUserDynamicPermissionsRequestToJSON(value?: SetUserDynamicPermissionsRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'permissions': value.permissions === undefined ? undefined : ((value.permissions as Array<any>).map(SetUserDynamicPermissionsRequestPermissionsInnerToJSON)),
    };
}

